import React, { useRef } from "react";
import { useField, Field } from "formik";
import AppInput, { AppInputProps } from "src/commun/composants/formulaire/AppInput/AppInput";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";

export type AppInputFormikProps = Omit<AppInputProps, "onChange" | "value" | "error"> & { formulaireSoumis?: boolean };

const AppInputFormik = ({ name, formulaireSoumis = false, isRequired = true, ...reste }: AppInputFormikProps) => {
  const [, { error, touched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  return (
    <Field fieldRef={ref} name={name} error={error} touched={formulaireSoumis || touched} isRequired={isRequired} as={AppInput} {...reste} />
  );
};

export default AppInputFormik;
